"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var ComponenticGlobe = function ComponenticGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    color: props.color
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11ZM8.66 3.64A9.009 9.009 0 0 0 3.054 11h3.964c.094-2.467.534-4.718 1.224-6.442.128-.32.267-.627.416-.918ZM12 3c-.189 0-.47.091-.83.473-.363.384-.736.992-1.07 1.827-.581 1.454-.986 3.443-1.08 5.7h5.96c-.094-2.257-.499-4.246-1.08-5.7-.334-.835-.707-1.443-1.07-1.827C12.47 3.092 12.19 3 12 3Zm4.981 8c-.094-2.467-.534-4.718-1.224-6.442-.128-.32-.267-.627-.416-.918A9.009 9.009 0 0 1 20.945 11h-3.964Zm-2.002 2H9.021c.093 2.257.498 4.246 1.079 5.7.334.835.707 1.444 1.07 1.827.36.381.641.473.83.473.189 0 .47-.091.83-.473.363-.384.736-.992 1.07-1.827.581-1.454.986-3.443 1.08-5.7Zm.362 7.36c.15-.29.288-.598.416-.918.69-1.724 1.13-3.975 1.224-6.442h3.964a9.009 9.009 0 0 1-5.604 7.36Zm-6.682 0c-.15-.29-.288-.598-.416-.918-.69-1.724-1.13-3.975-1.224-6.442H3.055a9.009 9.009 0 0 0 5.604 7.36Z",
    clipRule: "evenodd"
  }));
};
ComponenticGlobe.defaultProps = {
  color: "#161616"
};
var _default = ComponenticGlobe;
exports["default"] = _default;